import InviteFriendReferralLink from './InviteFriendReferralLink'

export default InviteFriendReferralLink
// eslint-disable-next-line import/export
export * from './InviteFriendReferralLink'
